import { requestAccessToken, isAuthenticated } from '@/api/canva';
import { getUser } from '@/api/user';
import store from '@/store';
import { onBeforeMount, onUnmounted, ref } from 'vue';

export const useCanva = (onUserUpdate: () => void, next: () => void) => {
    const canvaCodeVerifier = ref<string | null>(null);
    let popupWindow: Window | null = null;
    const openCanvaAuthPopup = (authorizationUrl: string) => {
        const width = 600;
        const height = 600;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;

        popupWindow = window.open(
            authorizationUrl,
            'canva_authorization_popup',
            `width=${width},height=${height},left=${left},top=${top}`
        );
    };

    const handleCanvaUserAuthorization = async (event: MessageEvent<{ code: string; action: string }>) => {
        const data = event.data;
        if (data.action !== 'canva-authorization-completed') return;
        if (!popupWindow || popupWindow.closed) return;
        if (!canvaCodeVerifier.value?.length) {
            popupWindow.close();
            return;
        }
        await requestAccessToken(canvaCodeVerifier.value, data.code, store.state?.user?.Username as string);
        onUserUpdate();
        popupWindow.close();
        await linkAccountToCanva();
    };

    const linkAccountToCanva = async () => {
        const user = store.state.user;
        if (!user?.Username) return;
        const response = await isAuthenticated(user.Username);
        if (response.isAuthenticated) {
            if (response.tokenRefreshed) {
                const user = await getUser();
                store.commit('user', user);
            }
            next();
            return;
        }
        if (!response.authorizationUrl?.length) return;
        canvaCodeVerifier.value = response.codeVerifier!;
        openCanvaAuthPopup(response.authorizationUrl);
    };

    onBeforeMount(() => {
        window.addEventListener('message', (event) => handleCanvaUserAuthorization(event));
    });

    onUnmounted(() => {
        window.removeEventListener('message', (event) => handleCanvaUserAuthorization(event));
    });
    return { linkAccountToCanva };
};
